import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllTeam } from '@/pages/baseData/team/api'
import { cloneDeep, getLocalStorage, setLocalStorage } from '@/utils/tools'

const teamCacheKey = 'cache-team'
const teamCache = getLocalStorage(teamCacheKey)
export const fetchGetTeamsAsync = createAsyncThunk('team/page', () =>
  axios
    .get(getAllTeam(teamCache?.version ?? ''))
    .then((response) => {
      const resp = response?.data
      if (resp === null) return []
      if (resp.data === null && resp.version === teamCache?.version) {
        return teamCache.data ?? []
      } else {
        setLocalStorage(teamCacheKey, resp)
        return resp.data ?? []
      }
    })
    .catch((err) => {
      throw Error('读取班组数据缓存失败')
    })
)

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    teamList: [],
    teamDisabledList: [],
    teamDict: {},
  },
  reducers: {
    setTeamList(state, action) {
      state.teamList = action.payload.items
    },
    setTeamDict(state, action) {
      state.teamDict = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetTeamsAsync.pending, (state) => {
        state.teamList = []
        state.teamDisabledList = []
        state.teamDict = {}
      })
      .addCase(fetchGetTeamsAsync.fulfilled, (state, action) => {
        state.teamList = action.payload
        state.teamDisabledList = cloneDeep(action.payload)
        if (state.teamList) {
          state.teamList.forEach((item) => {
            state.teamDict[item.id] = item
          })
          state.teamDisabledList.map((item) => {
            item.disabled = item.status == '0' ? true : false
          })
        }
      })
  },
})

export const { setTeamList, setTeamDict } = teamSlice.actions
export const getTeamList = (state) => state.team.teamList
export const getTeamDisabledList = (state) => state.team.teamDisabledList
export const getTeamDict = (state) => state.team.teamDict
export default teamSlice.reducer
